import { createAsyncThunk } from "@reduxjs/toolkit";
import { closeSnackbar, enqueueSnackbar, SnackbarKey } from "notistack";
import { getResourceExplorerViewsHierarchyThunk } from "./getResourceExplorerViewsHierarchyThunk";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";

interface UpdateResourceExplorerViewNameThunkArg {
  id: string;
  name: string;
}
export const updateResourceExplorerViewNameThunk = createAsyncThunk(
  "resourceExplorer/updateResourceExplorerViewName",
  async (
    { name, id }: UpdateResourceExplorerViewNameThunkArg,
    { dispatch },
  ) => {
    const {
      patchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId,
    } = cloudChiprApi.endpoints;

    try {
      await dispatch(
        patchUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId.initiate(
          {
            resourceExplorerViewId: id,
            body: { name },
          },
          { fixedCacheKey: id },
        ),
      ).unwrap();

      dispatch(getResourceExplorerViewsHierarchyThunk());
      const snackbarId: SnackbarKey = enqueueSnackbar(
        "View name successfully updated.",
        {
          variant: "snackbarAlert",
          AlertSnackBarProps: {
            severity: "success",
            onClose: () => closeSnackbar(snackbarId),
          },
        },
      );
    } catch (e) {
      // @ts-expect-error TODO: return to this after adding error type
      const errMessage = e?.data?.message || "Something went wrong";
      const snackbarId: SnackbarKey = enqueueSnackbar(errMessage, {
        variant: "snackbarAlert",
        AlertSnackBarProps: {
          severity: "error",
          onClose: () => closeSnackbar(snackbarId),
        },
      });
    }
  },
);
